(function () {
  var modalWrap = document.querySelector('[data-upsell-modal]');
  if (!modalWrap) return;

  var DISCOUNT_RATE = 0.10; // must match the Automatic Discount configured in Shopify admin
  var formPrefix = modalWrap.dataset.formIdPrefix;
  var drawersEnabled = modalWrap.dataset.drawersEnabled === 'true';
  var cardsEl = modalWrap.querySelector('[data-upsell-cards]');
  var checkoutBtn = modalWrap.querySelector('[data-proceed]');

  var pendingMain = null;   // { variantId, quantity }
  var cardState = [];       // [{ variantId, selected }]

  function closeModal() {
    modalWrap.hidden = true;
    cardsEl.innerHTML = '';
    cardState = [];
  }
  modalWrap.querySelectorAll('[data-upsell-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      closeModal();
      submitAndGo([{ id: pendingMain.variantId, quantity: pendingMain.quantity }], '/cart');
    });
  });

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function fetchProductJSON(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function findDrawerVariant(drawersProduct, size, finish) {
    if (!drawersProduct) return null;
    return drawersProduct.variants.find(function (v) {
      var opts = [v.option1, v.option2, v.option3].filter(Boolean);
      return opts.includes(size) && opts.includes(finish);
    }) || null;
  }

  function buildCard(entry, large) {
    var discounted = Math.round(entry.price * (1 - DISCOUNT_RATE));
    var wrap = document.createElement('div');
    wrap.className = 'upsell-card' + (large ? ' upsell-card--large' : '');
    wrap.innerHTML =
      (entry.image ? '<img class="upsell-card__img" src="' + entry.image + '" alt="">' : '') +
      '<div class="upsell-card__body">' +
        '<p class="upsell-card__name">' + entry.name + '</p>' +
        '<p class="upsell-card__message">' + entry.message + '</p>' +
        '<p class="upsell-card__price"><s>' + money(entry.price) + '</s><b>' + money(discounted) + '</b></p>' +
      '</div>' +
      '<button type="button" class="upsell-card__toggle">Add</button>';

    var toggleBtn = wrap.querySelector('.upsell-card__toggle');
    toggleBtn.addEventListener('click', function () {
      entry.selected = !entry.selected;
      wrap.classList.toggle('is-added', entry.selected);
      toggleBtn.textContent = entry.selected ? 'Added' : 'Add';
    });

    return wrap;
  }

  function buildLinkCard(name, message, url) {
    var wrap = document.createElement('a');
    wrap.href = url;
    wrap.className = 'upsell-card upsell-card--link';
    wrap.innerHTML =
      '<div class="upsell-card__body">' +
        '<p class="upsell-card__name">' + name + '</p>' +
        '<p class="upsell-card__message">' + message + '</p>' +
      '</div>' +
      '<span class="upsell-card__toggle">Browse</span>';
    return wrap;
  }

  function submitAndGo(items, destination) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () {
      window.location.href = destination;
    });
  }

  checkoutBtn.addEventListener('click', function () {
    var items = [{ id: pendingMain.variantId, quantity: pendingMain.quantity }];
    cardState.forEach(function (c) {
      if (c.selected) items.push({ id: c.variantId, quantity: 1 });
    });
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Adding...';
    submitAndGo(items, '/checkout');
  });

  function getSelectedVariant(form) {
    var section = form.closest('[data-product-id]');
    var textarea = section.querySelector('[data-current-variant-json]');
    if (textarea) {
      try { return JSON.parse(textarea.textContent); } catch (e) {}
    }
    return null;
  }

  async function openModalForForm(form) {
    var variant = getSelectedVariant(form);
    if (!variant) return false;

    var qtyInput = form.querySelector('input[name="quantity"]');
    pendingMain = {
      variantId: variant.id,
      quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1
    };

    var size = (variant.option1 === 'Full' || variant.option1 === 'Queen') ? variant.option1 : null;
    var frameColor = [variant.option1, variant.option2, variant.option3].find(function (v) {
      return v && v !== size && v !== 'No Mattress';
    });

    cardsEl.innerHTML = '';
    cardState = [];
    if (drawersEnabled && size) {
var INSITU_DRAWER_IMAGES = {
        'Mission Arm': {
          'Espresso': 'https://cdn.shopify.com/s/files/1/0984/8678/0221/files/monterey-frame-queen-espresso-finish-frame-storage-drawers.jpeg',
          'Butternut': 'https://cdn.shopify.com/s/files/1/0984/8678/0221/files/0d5a6575-monterey-frame-butternut-finish-linen-cocoa-mattress-storage-drawers.jpg'
        },
        'Lexington': {
          'Weathered White': 'https://cdn.shopify.com/s/files/1/0984/8678/0221/files/0b354e24-lexington-frame-weathered-white-finish-takara-rain-mattress-storage-drawers-without-shadow.jpg'
        }
      };

      var drawersProduct = await fetchProductJSON('futon-storage-drawers');
      var match = findDrawerVariant(drawersProduct, size, frameColor);
      if (match) {
        var family = modalWrap.dataset.productFamily;
        var insitu = (INSITU_DRAWER_IMAGES[family] || {})[frameColor];
        var drawerImage = insitu
          || (match.featured_image && match.featured_image.src)
          || drawersProduct.featured_image
          || null;

        var drawerEntry = {
          variantId: match.id,
          name: 'Storage Drawers — ' + frameColor,
          message: 'Add extra storage in a matching wood finish.',
          price: match.price,
          image: drawerImage,
          selected: false
        };
        cardState.push(drawerEntry);
        cardsEl.appendChild(buildCard(drawerEntry, true));
      }
      // no matching finish for this color → card simply omitted
    }

    var gripPadProduct = await fetchProductJSON('grip-pad-for-futon-frame');
    if (gripPadProduct && gripPadProduct.variants.length) {
      var gp = gripPadProduct.variants[0];
      var gpEntry = {
        variantId: gp.id,
        name: 'Non-Slip Grip Pad',
        message: 'Prevents the mattress from slipping, custom-cut to your size.',
        price: gp.price,
        image: gripPadProduct.featured_image || 'https://cdn.shopify.com/s/files/1/0984/8678/0221/files/gripper-pad-futon-frame.png',
        selected: false
      };
      cardState.push(gpEntry);
      cardsEl.appendChild(buildCard(gpEntry));
    }

    if (cardState.length === 0) return false; // nothing to offer

    checkoutBtn.disabled = false;
    checkoutBtn.textContent = 'Proceed to Checkout';
    modalWrap.hidden = false;
    return true;
  }

  function bindInterception() {
    var forms = document.querySelectorAll('form[id^="' + formPrefix + '"]');
    forms.forEach(function (form) {
      var triggers = form.querySelectorAll('[type="submit"], button[name="add"]');
      triggers.forEach(function (btn) {
        function handler(e) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();

          openModalForForm(form).then(function (opened) {
            if (opened === false) {
              btn.removeEventListener('click', handler, true);
              btn.click();
              btn.addEventListener('click', handler, true);
            }
          });
        }
        btn.addEventListener('click', handler, true);
      });
    });
  }

  bindInterception();
})();